import { Controller } from "@hotwired/stimulus"

// "Find on the map" on the staff event form: asks the desk where the venue,
// city and country typed are (OpenStreetMap, through the server, so the
// address is looked up the way the research import looked up its places) and
// fills the two coordinates. Nothing is saved; the person checks the place it
// names, with a link to see it, and saves the form.
export default class extends Controller {
  static targets = ["venue", "city", "country", "latitude", "longitude", "status", "button"]
  static values = { url: String }

  async locate() {
    this.say("Looking it up…")
    this.buttonTarget.disabled = true
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": this.token },
        body: JSON.stringify({
          venue_name: this.venueTarget.value,
          city: this.cityTarget.value,
          country_code: this.countryTarget.value
        })
      })
      const answer = await response.json()
      if (!answer.ok) return this.say(answer.message)

      this.latitudeTarget.value = answer.latitude
      this.longitudeTarget.value = answer.longitude
      this.say(`Found: ${answer.label || "a place"}. `, answer.latitude, answer.longitude)
    } catch {
      this.say("The lookup did not answer. Type the coordinates, or try again.")
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  // Text and, when there is a place, a link to it on OpenStreetMap: built
  // from nodes, never from HTML, because the label is somebody else's words.
  say(text, latitude, longitude) {
    this.statusTarget.textContent = text
    if (latitude === undefined) return

    const link = document.createElement("a")
    link.href = `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=16/${latitude}/${longitude}`
    link.target = "_blank"
    link.rel = "noopener"
    link.textContent = "Check it on OpenStreetMap, then save."
    this.statusTarget.append(link)
  }

  get token() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
